import { ModalEditRegsterStyled } from "../../../Modal/ModalEditRegister/styles";
import { Modal } from "../../../Modal";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { UserContext } from "../../../../providers/UserContext";
import { zodResolver } from "@hookform/resolvers/zod";
import { ButtonStyled } from "../../../Button/styles";
import { SubmitHandler, useForm } from "react-hook-form";
import { Input } from "../../../../assets/styles/Input";
import { iLoginData, loginSchema } from "./login.schema";
import { ModalResetPassword } from "../ResetSenha/ModalEmail/forgotSenha";

type iModalLogin = {
	showLogin: boolean;
	setShowLogin: Dispatch<SetStateAction<boolean>>;
};

export const ModalLoginHeader = ({ showLogin, setShowLogin }: iModalLogin) => {
	const { userLogin } = useContext(UserContext);

	const [showForgotSenha, setShowForgotSenha] = useState(false);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<iLoginData>({
		resolver: zodResolver(loginSchema),
	});

	const submitLogin: SubmitHandler<iLoginData> = (loginData) => {
		userLogin(loginData, setShowLogin);
	};

	return (
		<ModalEditRegsterStyled>
			{showLogin && (
				<Modal showModal={setShowLogin}>
					<div className="card">
						<h1>Entrar</h1>
						<div className="form">
							<form onSubmit={handleSubmit(submitLogin)}>
								<Input
									type="email"
									id="email"
									placeholder="Email"
									autoComplete="on"
									{...register("email")}
									alt="Email"
								/>
								<Input
									type="password"
									id="password"
									placeholder="Senha"
									autoComplete="on"
									{...register("password")}
									alt="Senha"
								/>
								<ButtonStyled type="submit">Entrar</ButtonStyled>
							</form>
						</div>
						<p
							onClick={() => {
								setShowForgotSenha(true);
								setShowLogin(false);
							}}
						>
							Esqueci a senha
						</p>
					</div>
				</Modal>
			)}
			<ModalResetPassword
				showForgotSenha={showForgotSenha}
				setShowForgotSenha={setShowForgotSenha}
			/>
		</ModalEditRegsterStyled>
	);
};
